<template>
  <div class="merchant-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="入驻状态">
          <el-select v-model="searchForm.joinStatus" placeholder="全部" clearable style="width: 130px">
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="已入驻" :value="1"></el-option>
            <el-option label="审核驳回" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input
              v-model="searchForm.keyword"
              placeholder="商家名称/联系人"
              clearable
              style="width: 200px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column label="LOGO" width="80" align="center">
          <template slot-scope="{ row }">
            <el-image
                v-if="row.showLogo"
                :src="row.showLogo"
                :preview-src-list="[row.showLogo]"
                style="width: 40px; height: 40px; border-radius: 4px;"
                fit="cover"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" style="font-size: 20px; color: #c0c4cc;"></i>
              </div>
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商家名称" min-width="150"></el-table-column>
        <el-table-column prop="storeName" label="门店名称" min-width="140"></el-table-column>
        <el-table-column label="门店照片" width="120" align="center">
          <template slot-scope="{ row }">
            <div style="display: flex; justify-content: center; gap: 5px;">
              <el-image
                  v-for="(img, index) in (row.showStoreImgUrls || [])"
                  :key="index"
                  :src="img"
                  :preview-src-list="(row.showStoreImgUrls || [])"
                  fit="cover"
                  style="width: 40px; height: 40px; border-radius: 4px;"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" style="font-size: 20px; color: #c0c4cc;"></i>
                </div>
              </el-image>
            </div>
            <span v-if="!row.showStoreImgUrls || row.showStoreImgUrls.length === 0">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="contact" label="联系人" width="100"></el-table-column>
        <el-table-column prop="phone" label="联系电话" width="130"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="入驻状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.joinStatus)" size="small">
              {{ statusText(row.joinStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="营业状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
              {{ row.status === 1 ? '营业中' : '已关闭' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="知情同意书" width="100" align="center">
          <template slot-scope="{ row }">
            <el-image
                v-if="row.showAttachmentUrl"
                :src="row.showAttachmentUrl"
                :preview-src-list="[row.showAttachmentUrl]"
                style="width: 40px; height: 40px; border-radius: 4px;"
                fit="cover"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" style="font-size: 20px; color: #c0c4cc;"></i>
              </div>
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="{ row }">
            <div class="op-line">
              <el-button size="mini" type="primary" @click="$router.push(`/merchant/detail/${row.id}`)">
                详情
              </el-button>

              <el-button size="mini" @click="openEdit(row)">修改</el-button>
            </div>

            <div class="op-line">
              <template v-if="row.joinStatus === 0">
                <el-button size="mini" type="success" @click="handleApprove(row)">通过</el-button>
                <el-button size="mini" type="danger" @click="handleReject(row)">驳回</el-button>
              </template>

              <el-button
                  v-if="row.joinStatus === 1"
                  size="mini"
                  type="warning"
                  @click="openClaimConfig(row)"
              >
                限领
              </el-button>

              <el-button
                  v-if="row.joinStatus !== 0"
                  size="mini"
                  :type="row.status === 1 ? 'warning' : 'success'"
                  @click="handleToggle(row)"
              >
                {{ row.status === 1 ? '禁用' : '启用' }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 审核备注弹窗 -->
    <el-dialog title="审核通过" :visible.sync="approveVisible" width="400px">
      <el-form>
        <el-form-item label="备注">
          <el-input v-model="approveRemark" type="textarea" :rows="3" placeholder="可选填备注信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="approveVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="doApprove">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 驳回原因弹窗 -->
    <el-dialog title="审核驳回" :visible.sync="rejectVisible" width="400px">
      <el-form>
        <el-form-item label="驳回原因" required>
          <el-input v-model="rejectReason" type="textarea" :rows="3" placeholder="请输入驳回原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="doReject">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改商家弹窗 -->
    <el-dialog title="修改商家" :visible.sync="editVisible" width="760px" :close-on-click-modal="false" @close="onEditDialogClose">
      <el-form ref="editFormRef" :model="editForm" label-width="110px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="商家名称" required>
              <el-input v-model="editForm.name" placeholder="请输入商家名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="门店名称" required>
              <el-input v-model="editForm.storeName" placeholder="请输入门店名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属社区">
              <el-input v-model="editForm.community" placeholder="请输入所属社区"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="editForm.contact" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="editForm.phone" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信">
              <el-input v-model="editForm.wechat" placeholder="请输入微信"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="地址">
              <el-input v-model="editForm.address" placeholder="请输入地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经度">
              <el-input-number v-model="editForm.longitude" :precision="6" :controls="true" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度">
              <el-input-number v-model="editForm.latitude" :precision="6" :controls="true" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业开始">
              <el-time-select v-model="editForm.businessStart" :picker-options="{start:'00:00',step:'00:30',end:'23:30'}" placeholder="开始时间"></el-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业结束">
              <el-time-select v-model="editForm.businessEnd" :picker-options="{start:'00:00',step:'00:30',end:'23:30'}" placeholder="结束时间"></el-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业开始2">
              <el-time-select v-model="editForm.business2Start" :picker-options="{start:'00:00',step:'00:30',end:'23:30'}" placeholder="可选"></el-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业结束2">
              <el-time-select v-model="editForm.business2End" :picker-options="{start:'00:00',step:'00:30',end:'23:30'}" placeholder="可选"></el-time-select>
            </el-form-item>
          </el-col>

          <!-- 营业执照：单图上传，bizType=merchant_license -->
          <el-col :span="24">
            <el-form-item label="营业执照">
              <el-upload
                  class="single-img-upload"
                  list-type="picture-card"
                  action="#"
                  :file-list="editForm.licenseFiles"
                  :http-request="(opt)=>uploadSingle(opt,'merchant_license','licenseFiles','licenseUrl')"
                  :on-change="(file,fileList)=>handleSingleReplace(fileList,'licenseFiles','licenseUrl')"
                  :on-remove="(file,list)=>onSingleRemove(list,'licenseFiles','licenseUrl')"
                  accept="image/*"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="upload-tip">营业执照，仅支持单张图片，选图后自动上传</div>
            </el-form-item>
          </el-col>

          <!-- LOGO：单图上传，bizType=merchant_logo -->
          <el-col :span="24">
            <el-form-item label="LOGO">
              <el-upload
                  class="single-img-upload"
                  list-type="picture-card"
                  action="#"
                  :file-list="editForm.logoFiles"
                  :http-request="(opt)=>uploadSingle(opt,'merchant_logo','logoFiles','logo')"
                  :on-change="(file,fileList)=>handleSingleReplace(fileList,'logoFiles','logo')"
                  :on-remove="(file,list)=>onSingleRemove(list,'logoFiles','logo')"
                  accept="image/*"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="upload-tip">门店 LOGO，仅支持单张图片，选图后自动上传</div>
            </el-form-item>
          </el-col>

          <!-- 门店照片：多图上传（选多张后一次请求） -->
          <el-col :span="24">
            <el-form-item label="门店照片">
              <el-upload
                  ref="storeImgUpload"
                  class="store-img-upload"
                  list-type="picture-card"
                  action="#"
                  :file-list="editForm.storeImgFiles"
                  :auto-upload="false"
                  :multiple="true"
                  :on-change="handleStoreImgChange"
                  :on-remove="onStoreImgRemove"
                  accept="image/*"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="upload-tip">
                门店照片，支持多选一次上传；选择图片后自动批量上传（仅请求一次接口），点击图片可预览
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="门店简介">
              <el-input v-model="editForm.summary" type="textarea" :rows="3" placeholder="请输入门店简介"></el-input>
            </el-form-item>
          </el-col>


          <!-- 承诺书：单图上传，bizType=merchant_attachment -->
          <el-col :span="24">
            <el-form-item label="承诺书">
              <el-upload
                  class="single-img-upload"
                  list-type="picture-card"
                  action="#"
                  :file-list="editForm.attachmentFiles"
                  :http-request="(opt)=>uploadSingle(opt,'merchant_attachment','attachmentFiles','attachmentUrl')"
                  :on-change="(file,fileList)=>handleSingleReplace(fileList,'attachmentFiles','attachmentUrl')"
                  :on-remove="(file,list)=>onSingleRemove(list,'attachmentFiles','attachmentUrl')"
                  accept="image/*"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="upload-tip">承诺书，仅支持单张图片，选图后自动上传</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="doUpdate">确 定</el-button>
      </div>
    </el-dialog>



    <el-dialog
        title="商家限领设置"
        :visible.sync="claimVisible"
        width="420px"
        :close-on-click-modal="false"
    >
      <el-form label-width="90px" size="small">
        <el-form-item label="限领开关">
          <el-switch
              v-model="claimForm.enabled"
              active-text="开启"
              inactive-text="关闭"
          />
        </el-form-item>

        <el-form-item label="限领天数">
          <el-input-number
              v-model="claimForm.canClaimDay"
              :min="1"
              :max="365"
              :disabled="!claimForm.enabled"
              controls-position="right"
              style="width: 160px;"
          />
          <div class="upload-tip" style="margin-top: 6px;">
            关闭：不限制领取<br/>
            开启：每 N 天最多领取 1 次
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="claimVisible = false">取消</el-button>
        <el-button
            type="primary"
            :loading="claimSubmitting"
            @click="saveClaimConfig"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMerchantList, approveMerchant, rejectMerchant, toggleMerchant, updateMerchant,saveMerchantClaimConfig } from '@/api/merchant'
import { uploadImages } from '@/api/upload'

/**
 * 从后端上传响应中取图片 URL 列表。
 * 后端返回 { fileUrls, showFileUrls(已拼接域名前缀), show }，
 * 优先使用 showFileUrls（已带域名，可直接用于展示/回显）。
 */
function pickUrlList(res) {
  if (!res) return []
  const body = res.data !== undefined ? res.data : res
  if (!body) return []
  const list = body.showFileUrls || body.fileUrls || body.fileURLs || body.urls || (body.fileUrl ? [body.fileUrl] : null)
  if (!Array.isArray(list)) return []
  return list.filter(Boolean).map(String)
}

/**
 * 取不带域名前缀的原始 URL 列表（用于提交/存库）。
 * 优先使用 fileUrls；若无则回退到 showFileUrls。
 */
function pickRawUrlList(res) {
  if (!res) return []
  const body = res.data !== undefined ? res.data : res
  if (!body) return []
  let list = body.fileUrls || body.fileURLs || body.urls || (body.fileUrl ? [body.fileUrl] : null)
  if (!Array.isArray(list)) list = []
  if (!list.length) list = body.showFileUrls || []
  return list.filter(Boolean).map(String)
}

function pickRawUrl(res) {
  if (!res) return ''
  const body = res.data !== undefined ? res.data : res
  if (!body) return ''
  const list = body.fileUrls || body.fileURLs || body.urls || (body.fileUrl ? [body.fileUrl] : [])
  if (!Array.isArray(list)) return ''
  return list[0] || ''
}

function getEmptyEditForm() {
  return {
    id: '',
    name: '',
    storeName: '',
    community: '',
    contact: '',
    phone: '',
    wechat: '',
    address: '',
    longitude: 0,
    latitude: 0,
    businessStart: '',
    businessEnd: '',
    business2Start: '',
    business2End: '',
    licenseUrl: '',
    attachmentUrl: '',
    logo: '',
    storeImgUrls: [],
    licenseFiles: [],
    logoFiles: [],
    attachmentFiles: [],
    storeImgFiles: [],
    summary: '',
  }
}

export default {
  name: 'MerchantList',
  data() {
    return {
      searchForm: { joinStatus: '', keyword: '' },
      tableData: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      approveVisible: false,
      rejectVisible: false,
      approveRemark: '',
      rejectReason: '',
      currentRow: null,
      submitting: false,
      editVisible: false,
      editForm: getEmptyEditForm(),
      // 门店照片：待上传的原始 File 对象缓存
      storeImgRawFiles: [],
      // 单图（营业执照 / LOGO / 承诺书）上传序号，用于丢弃被顶替的旧上传结果
      singleUploadSeq: {},
      claimVisible: false,
      claimSubmitting: false,
      claimForm: {
        merchantId: null,
        enabled: false,
        canClaimDay: 7
      }
    }
  },
  mounted() { this.loadData() },
  methods: {
    /* ---------- 列表 / 审核 ---------- */
    async loadData() {
      this.loading = true
      try {
        const res = await getMerchantList(this.searchForm.joinStatus, this.searchForm.keyword, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm = { joinStatus: '', keyword: '' }; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    statusType(s) { return s === 0 ? 'warning' : s === 1 ? 'success' : 'danger' },
    statusText(s) { return s === 0 ? '待审核' : s === 1 ? '已入驻' : '审核驳回' },
    handleApprove(row) { this.currentRow = row; this.approveRemark = ''; this.approveVisible = true },
    async doApprove() {
      this.submitting = true
      try {
        await approveMerchant(this.currentRow.id, this.approveRemark)
        this.$message.success('审核通过')
        this.approveVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    handleReject(row) { this.currentRow = row; this.rejectReason = ''; this.rejectVisible = true },
    async doReject() {
      if (!this.rejectReason.trim()) return this.$message.warning('请输入驳回原因')
      this.submitting = true
      try {
        await rejectMerchant(this.currentRow.id, this.rejectReason)
        this.$message.success('已驳回')
        this.rejectVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    async handleToggle(row) {
      try {
        await toggleMerchant(row.id)
        this.$message.success(row.status === 1 ? '已禁用' : '已启用')
        this.loadData()
      } catch (e) {}
    },

    /* ---------- 修改弹窗 ---------- */
    openEdit(row) {
      const f = getEmptyEditForm()
      f.id = row.id
      f.name = row.name || ''
      f.storeName = row.storeName || ''
      f.community = row.community || ''
      f.contact = row.contact || ''
      f.phone = row.phone || ''
      f.wechat = row.wechat || ''
      f.address = row.address || ''
      f.longitude = Number(row.longitude) || 0
      f.latitude = Number(row.latitude) || 0
      f.businessStart = row.businessStart || ''
      f.businessEnd = row.businessEnd || ''
      f.business2Start = row.business2Start || ''
      f.business2End = row.business2End || ''
      f.licenseUrl = row.licenseUrl || ''
      f.logo = row.logo || ''
      f.summary = row.summary || ''
      f.licenseFiles = row.licenseUrl
          ? [{ name: 'license', url: row.showLicenseUrl || row.licenseUrl }]
          : []
      f.logoFiles = row.logo
          ? [{ name: 'logo', url: row.showLogo || row.logo }]
          : []

      f.attachmentFiles = row.attachmentUrl
          ? [{ name: 'attachmentUrl', url: row.showAttachmentUrl || row.attachmentUrl }]
          : []
      // 展示用带域名的 showStoreImgUrls；提交用不带域名的 storeImgUrls
      const showImgs = Array.isArray(row.showStoreImgUrls) ? row.showStoreImgUrls : []
      const rawImgs = Array.isArray(row.storeImgUrls) ? row.storeImgUrls : []
      f.storeImgFiles = showImgs.length
          ? showImgs.map((url, i) => ({ name: 'img_' + i, url: url }))
          : rawImgs.map((url, i) => ({ name: 'img_' + i, url: url }))
      f.storeImgUrls = rawImgs.slice()
      this.editForm = f
      this.storeImgRawFiles = []
      this.editVisible = true
    },
    onEditDialogClose() {
      this.editForm = getEmptyEditForm()
      this.storeImgRawFiles = []
    },
    async doUpdate() {
      if (!this.editForm.name || !this.editForm.storeName) {
        return this.$message.warning('商家名称、门店名称为必填')
      }
      this.submitting = true
      try {
        const payload = {
          name: this.editForm.name,
          storeName: this.editForm.storeName,
          community: this.editForm.community,
          contact: this.editForm.contact,
          phone: this.editForm.phone,
          wechat: this.editForm.wechat,
          address: this.editForm.address,
          longitude: Number(this.editForm.longitude),
          latitude: Number(this.editForm.latitude),
          businessStart: this.editForm.businessStart,
          businessEnd: this.editForm.businessEnd,
          business2Start: this.editForm.business2Start,
          business2End: this.editForm.business2End,
          licenseUrl: this.editForm.licenseUrl,
          attachmentUrl: this.editForm.attachmentUrl,
          logo: this.editForm.logo,
          // 提交原始（不带域名）门店照片 URL 数组
          storeImgUrls: (this.editForm.storeImgUrls || []).map(u => String(u).trim()).filter(Boolean),
          summary: this.editForm.summary
        }
        await updateMerchant(this.editForm.id, payload)
        this.$message.success('修改成功')
        this.editVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },

    /* ---------- 图片上传 ---------- */
    /**
     * 单图（营业执照 / LOGO / 承诺书）"直接替换"：
     * 不使用 :limit="1"（达到限制后 el-upload 会隐藏 picture-card 的 + 号，
     * 必须先删后传）。改为监听 on-change，只保留最后一次选中的那张，
     * 新图一选中就顶掉旧图并自动上传，实现"上传即替换"。
     */
    handleSingleReplace(fileList, filesKey, urlKey) {
      if (!Array.isArray(fileList)) return
      if (fileList.length > 1) {
        // 只保留最新选中的一张，旧图（含回显的历史图）直接被顶掉
        fileList.splice(0, fileList.length - 1)
        // 旧图已被替换，先清空原 URL，避免新图上传期间误提交旧图
        if (urlKey) this.editForm[urlKey] = ''
      }
      // 递增序号：连续快速替换时，旧一次上传的返回结果将被丢弃
      this.singleUploadSeq[filesKey] = (this.singleUploadSeq[filesKey] || 0) + 1
    },

    // 单图上传（营业执照 / LOGO / 承诺书）
    async uploadSingle(opt, bizType, filesKey, urlKey) {
      const file = opt.file
      if (!file) { opt.onError && opt.onError(new Error('no file')); return }
      const seq = this.singleUploadSeq[filesKey] = (this.singleUploadSeq[filesKey] || 0) + 1
      try {
        const res = await uploadImages([file], bizType)
        // 期间又选了新图，本次结果作废
        if (this.singleUploadSeq[filesKey] !== seq) {
          opt.onError && opt.onError(new Error('replaced'))
          return
        }

        // ✅ 提交用：不带域名
        const rawUrl = pickRawUrl(res)
        if (!rawUrl) {
          this.$message.error('图片上传失败：未返回 URL')
          opt.onError && opt.onError(new Error('no url'))
          return
        }

        // ✅ 回显用：带域名
        const showUrls = pickUrlList(res)
        const showUrl = showUrls[0] || rawUrl

        this.editForm[urlKey] = rawUrl
        // 预览列表同样只保留刚上传成功的这一张（回显用带域名的 URL）
        this.editForm[filesKey] = [{ name: file.name || 'image', url: showUrl }]

        opt.onSuccess && opt.onSuccess(res, file)
      } catch (e) {
        this.$message.error('图片上传异常')
        opt.onError && opt.onError(e)
      }
    },
    onSingleRemove(fileList, filesKey, urlKey) {
      this.editForm[filesKey] = fileList || []
      this.editForm[urlKey] = ''
    },

    /* ---------- 门店照片：多图一次请求 ---------- */
    // 收集选中的文件（el-upload 默认会自动加入内部 file-list 用于预览）
    // 当选中文件发生变化时，自动触发一次批量上传（多张只请求一次接口）
    handleStoreImgChange(file, fileList) {
      // 仅保留包含原始 File 对象的项
      const raws = fileList.filter(f => f.raw).map(f => f.raw)
      this.storeImgRawFiles = raws
      // 有文件且当前没有正在进行的上传，则自动批量上传
      if (raws.length && !this._storeImgUploading) {
        this._storeImgUploading = true
        // 等当前事件循环结束再执行，确保 file-list 状态稳定
        this.$nextTick(() => {
          this.uploadStoreImgs().finally(() => {
            this._storeImgUploading = false
          })
        })
      }
    },
    // 将当前已选中的多张图片一次上传（选多张后只请求一次接口）
    async uploadStoreImgs() {
      // 快照当前待上传文件，并立即清空缓存，防止 on-change 再次触发时重复上传
      const files = this.storeImgRawFiles.slice()
      if (!files.length) return
      this.storeImgRawFiles = []
      this.submitting = true
      try {
        const res = await uploadImages(files, 'store_img')
        // 展示用：带域名前缀的 URL
        const showUrls = pickUrlList(res)
        // 提交用：不带域名的原始 URL
        const rawUrls = pickRawUrlList(res)
        if (!showUrls.length || !rawUrls.length) {
          this.$message.error('门店图片上传失败：未返回 URL')
          return
        }
        const baseTs = Date.now()
        const newFiles = showUrls.map((url, i) => ({
          name: 'img_' + (baseTs + i),
          url: url
        }))
        // 展示列表（带域名）
        this.editForm.storeImgFiles = this.editForm.storeImgFiles.concat(newFiles)
        // 提交列表（原始 URL，不带域名）
        this.editForm.storeImgUrls = this.editForm.storeImgUrls.concat(rawUrls)
        this.$message.success(`成功上传 ${showUrls.length} 张门店图片`)
      } catch (e) {
        console.error('[uploadStoreImgs] 上传异常:', e)
        this.$message.error('门店图片上传异常')
      } finally {
        this.submitting = false
        // 清空 el-upload 内部待上传列表，避免重复上传
        if (this.$refs.storeImgUpload) {
          this.$refs.storeImgUpload.clearFiles()
        }
      }
    },
    onStoreImgRemove(file, fileList) {
      const newFiles = fileList.map(f => ({
        name: f.name,
        url: f.url || ''
      }))
      // 按索引同步删除 storeImgUrls 中对应项（files 与 urls 一一对应）
      const removedIdx = this.editForm.storeImgFiles.findIndex(f => f === file || f.uid === file.uid)
      this.editForm.storeImgFiles = newFiles
      if (removedIdx > -1 && this.editForm.storeImgUrls.length > removedIdx) {
        this.editForm.storeImgUrls = this.editForm.storeImgUrls.filter((_, i) => i !== removedIdx)
      }
    },

    async openClaimConfig(row) {
      this.claimForm.merchantId = row.id
      const day = Number(row.canClaimDay)

      this.claimForm.enabled = day > 0
      this.claimForm.canClaimDay = day > 0 ? day : 7   // 默认 7 天
      this.claimVisible = true
    },

    async saveClaimConfig() {
      this.claimSubmitting = true
      try {
        const payload = {
          canClaimDay: this.claimForm.enabled
              ? Math.max(1, Number(this.claimForm.canClaimDay) || 7) // 兜底 7
              : 0
        }

        await saveMerchantClaimConfig(this.claimForm.merchantId, payload)
        this.$message.success('限领配置已保存')
        this.claimVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.claimSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.merchant-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
.single-img-upload .el-upload--picture-card,
.store-img-upload .el-upload--picture-card { width: 100px; height: 100px; line-height: 100px; }
.upload-tip { font-size: 12px; color: #909399; margin-top: 6px; }
.op-line {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
}
.op-line:last-child {
  margin-bottom: 0;
}
</style>
